import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackgroundBox, ContentBox, Main } from './Layout.styled';
import { Footer, PageLoader } from './components';
import { NoAccess } from '@/shared/components';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useLayoutStore } from './business';
const Layout = ({ sidebarWidth, sidebar, accessDeniedMessage, hideFooter }) => {
    const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);
    return (_jsxs(BackgroundBox, { children: [sidebar, _jsxs(ContentBox, { sidebarCollapsed: sidebarCollapsed, sidebarWidth: sidebarWidth, children: [_jsx(Main, { sidebarCollapsed: sidebarCollapsed, children: _jsx(Suspense, { fallback: _jsx(PageLoader, {}), children: accessDeniedMessage ? _jsx(NoAccess, { customMessage: accessDeniedMessage }) : _jsx(Outlet, {}) }) }), !hideFooter && _jsx(Footer, {})] })] }));
};
export { Layout };
